export function getCorrectionsListFromContactInfoUpdateDict(contactInfoUpdatesByRecipientId) {
    const corrections = [];
    for (const recipientId in contactInfoUpdatesByRecipientId) {
        if (!contactInfoUpdatesByRecipientId.hasOwnProperty(recipientId)) {
            continue;
        }
        const contactInfoUpdate = contactInfoUpdatesByRecipientId[recipientId];
        corrections.push({
            PublicId: recipientId,
            Email: contactInfoUpdate.email,
            FirstName: contactInfoUpdate.first,
            LastName: contactInfoUpdate.last
        });
    }
    return corrections;
}
